import { render, staticRenderFns } from "./LiveScheduleRegistration.vue?vue&type=template&id=656c662f&scoped=true&"
import script from "./LiveScheduleRegistration.vue?vue&type=script&lang=js&"
export * from "./LiveScheduleRegistration.vue?vue&type=script&lang=js&"
import style0 from "./LiveScheduleRegistration.vue?vue&type=style&index=0&id=656c662f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656c662f",
  null
  
)

export default component.exports